import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "module card-module" }
const _hoisted_2 = { class: "row-of-inputs row-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "signal-icon",
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z" })
], -1 /* HOISTED */)
const _hoisted_4 = { class: "row-of-inputs row-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label port-a-label" }, "PORT A", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label port-b-label" }, "PORT B", -1 /* HOISTED */)

import "@style/modules/wire-matcher.scss";
import ModuleStatusIndicator from "@src/components/ModuleStatusIndicator.vue";
import { onMounted, ref } from "vue";
import WireJack from "@src/modules/WireMatcher/components/WireJack.vue";
import defineModuleState, {
  ModuleEmits,
  ModuleProps,
} from "@src/composables/defineModuleState";
import PortPin from "@src/modules/WireMatcher/structures/PortPin";
import _ from "lodash";
import {
  ConnectionState,
  validateConnection,
} from "@src/modules/WireMatcher/helpers/level";
import { decodeSerialNumber } from "@src/helpers/serialNumber";

const elementOffset = 18;

export default /*#__PURE__*/_defineComponent({
  __name: 'WireMatcherModule',
  props: ModuleProps,
  emits: ModuleEmits,
  setup(__props, { emit }) {

const props = __props;



const state = defineModuleState(props, emit);

state.onArmed(armModule);
state.onReady(restartModule);
state.onFailed(freezeModule);

const canvasElement = ref(null);
const contentElement = ref(null);
const startingPoint = ref<Array<number> | null>(null);
let selectedPortPin: PortPin;
let mousePosition: Array<number> = [0, 0];
let segmentsToDraw: Array<Array<number>> = [];
let connectedPortPins: Array<Array<PortPin>> = [];
let isFirstDigitOfSerialNumberOdd = false;

const colorClasses = ["red", "yellow", "green", "blue"];
const portColors: Array<Array<number | null>> = [
  [null, null, null, null, null],
  [null, null, null, null, null],
];

function armModule(): void {
  segmentsToDraw = [];
  connectedPortPins = [];
  generateColors();
  renderWires();

  const serialNumberStructure = decodeSerialNumber(props.serialNumber);
  isFirstDigitOfSerialNumberOdd = serialNumberStructure.isFirstDigitOdd;
}

function restartModule(): void {
  segmentsToDraw = [];
  connectedPortPins = [];
  clearColors();
  renderWires();
}

function freezeModule(): void {}

function selectInput(event: PointerEvent, port: number, pin: number) {
  if (!contentElement.value || !state.isArmed.value) {
    return;
  }
  const portPin = new PortPin(port, pin);
  const element = <HTMLElement>event.target;
  const rect = element.getBoundingClientRect();
  const contentRect = (<HTMLElement>(
    contentElement.value
  )).getBoundingClientRect();

  if (
    isPinOccupied(portPin) ||
    (startingPoint.value && selectedPortPin.isEqual(portPin))
  ) {
    return;
  }

  if (startingPoint.value === null) {
    startingPoint.value = [rect.x - contentRect.x, rect.y - contentRect.y];
    selectedPortPin = portPin;
  } else {
    const endingPoint = [rect.x - contentRect.x, rect.y - contentRect.y];
    segmentsToDraw.push([
      startingPoint.value[0] + elementOffset,
      startingPoint.value[1] + elementOffset,
      endingPoint[0] + elementOffset,
      endingPoint[1] + elementOffset,
    ]);

    connectedPortPins.push([selectedPortPin, portPin]);

    startingPoint.value = null;

    renderWires();

    let isConnectionValid = ConnectionState.INCORRECT;
    let pinA = null;
    let pinB = null;
    if (selectedPortPin.portIndex == 0 && portPin.portIndex === 1) {
      pinA = selectedPortPin.pinIndex;
      pinB = portPin.pinIndex;
    } else if (selectedPortPin.portIndex == 1 && portPin.portIndex === 0) {
      pinA = portPin.pinIndex;
      pinB = selectedPortPin.pinIndex;
    } else {
      isConnectionValid = ConnectionState.INCORRECT;
    }

    if (pinA !== null && pinB !== null) {
      isConnectionValid = validateConnection(
        pinA,
        pinB,
        portColors[0],
        portColors[1],
        isFirstDigitOfSerialNumberOdd,
      );
      portColors[0][pinA] = null;
      portColors[1][pinB] = null;
    }

    if (isConnectionValid == ConnectionState.CORRECT) {
      //Continue disarming
    } else if (isConnectionValid == ConnectionState.COMPLETED) {
      state.emitDisarmed();
    } else {
      state.emitFailed();
    }
  }
}

function isPinOccupied(portPin: PortPin): boolean {
  for (const portPinElement of connectedPortPins) {
    if (
      portPin.isEqual(portPinElement[0]) ||
      portPin.isEqual(portPinElement[1])
    ) {
      return true;
    }
  }

  return false;
}

function drawWire(ctx: CanvasRenderingContext2D, points: Array<number>): void {
  ctx.lineWidth = 12;
  ctx.strokeStyle = "#6c6c6c";
  ctx.lineCap = "round";
  ctx.shadowOffsetX = 4;
  ctx.shadowOffsetY = 4;
  ctx.shadowBlur = 7;
  ctx.shadowColor = "#3d3d3d";

  const cpOffset = 50;
  const cp1 = [
    points[0],
    points[1] > 130 ? points[1] - cpOffset : points[1] + cpOffset,
  ];
  const cp2 = [
    points[2],
    points[3] > 130 ? points[3] - cpOffset : points[3] + cpOffset,
  ];

  ctx.beginPath();
  ctx.moveTo(points[0], points[1]);
  ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], points[2], points[3]);
  ctx.stroke();
}

function handleMuseMove(event: MouseEvent): void {
  if (contentElement.value && state.isArmed.value) {
    const contentRect = (<HTMLElement>(
      contentElement.value
    )).getBoundingClientRect();
    mousePosition = [event.x - contentRect.x, event.y - contentRect.y];

    renderWires();
  }
}

function renderWires(): void {
  if (!canvasElement.value) {
    return;
  }

  const canvas = <HTMLCanvasElement>canvasElement.value; //document.getElementById("wire-canvas");
  if (canvas) {
    const ctx = <CanvasRenderingContext2D>canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (const segment of segmentsToDraw) {
      drawWire(ctx, segment);
    }

    if (startingPoint.value !== null) {
      const mSegment = [
        startingPoint.value[0] + elementOffset,
        startingPoint.value[1] + elementOffset,
        mousePosition[0],
        mousePosition[1],
      ];

      drawWire(ctx, mSegment);
    }
  }
}

function getColor(port: number, index: number): string {
  const colorIndex = portColors[port][index];
  if (colorIndex !== null) {
    return colorClasses[colorIndex];
  }
  return "";
}

function generateColors(): void {
  const numberOfPins = 5;

  for (let i = 0; i < numberOfPins; i++) {
    portColors[0][i] = Math.floor(Math.random() * 4);
  }

  for (let i = 0; i < numberOfPins; i++) {
    portColors[1][i] = Math.floor(Math.random() * 4);
    // portColors[1][i] = portColors[0][i];
  }

  portColors[0] = _.shuffle(portColors[0]);
  portColors[1] = _.shuffle(_.shuffle(portColors[1]));
}

function clearColors(): void {
  for (let i = 0; i < portColors[0].length; i++) {
    portColors[0][i] = null;
  }

  for (let i = 0; i < portColors[1].length; i++) {
    portColors[1][i] = null;
  }
}

function isSelected(port: number, pin: number): boolean {
  if (startingPoint.value !== null) {
    return selectedPortPin.isEqual(new PortPin(port, pin));
  }
  return false;
}

onMounted(() => {
  if (contentElement.value) {
    (<HTMLElement>contentElement.value).addEventListener(
      "mousemove",
      handleMuseMove,
    );
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "contentElement",
      ref: contentElement
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n, index) => {
          return _createVNode(WireJack, {
            key: index,
            "is-selected": isSelected(0, index),
            color: getColor(0, index),
            orientation: "down",
            onSelect: (e) => selectInput(e, 0, index)
          }, null, 8 /* PROPS */, ["is-selected", "color", "onSelect"])
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n, index) => {
          return _createVNode(WireJack, {
            key: index,
            "is-selected": isSelected(1, index),
            color: getColor(1, index),
            orientation: "up",
            onSelect: (e) => selectInput(e, 1, index)
          }, null, 8 /* PROPS */, ["is-selected", "color", "onSelect"])
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("canvas", {
        width: "400",
        height: "300",
        class: "wire-canvas",
        ref_key: "canvasElement",
        ref: canvasElement
      }, null, 512 /* NEED_PATCH */),
      _hoisted_5,
      _hoisted_6
    ], 512 /* NEED_PATCH */),
    _createVNode(ModuleStatusIndicator, {
      "is-armed": _unref(state).isArmed.value,
      "is-disarmed": _unref(state).isDisarmed.value
    }, null, 8 /* PROPS */, ["is-armed", "is-disarmed"])
  ]))
}
}

})